import { SingleChoice } from "../../../components/form/SingleChoice";
import { MultipleChoice } from "../../../components/form/MultipleChoice";
import { Input } from "../../../components/form/Input";
import { Textarea } from "../../../components/form/Textarea";
import { Datepicker } from "../../../components/form/Datepicker";
import { Select } from "../../../components/form/Select";

export const StandardField = ({
  fields,
  formData,
  changeData,
  errors,
  labelClassName = "input-label",
  className = "",
  classNameTextArea = "",
  hideRequiredLabel = false,
}) => {
  return fields.map((field, fieldIndex) => (
    <section key={fieldIndex}>
      <section id={`standard-${field.id}`} />
      {field.component === "standard-multielement" && (
        <section className={`standard-multielement`}>
          <StandardField
            fields={field.fields}
            formData={formData}
            changeData={changeData}
            errors={errors}
          />
        </section>
      )}
      {field.component === "input" && (
        <Input
          value={formData[field.id]}
          label={field.label}
          onChange={e => changeData(e, field)}
          error={errors[field.id]}
          type={field.type}
          required={field.required}
          labelClassName={labelClassName}
          placeholder={field.placeholder}
          className={className}
          hideRequiredLabel={hideRequiredLabel}
        />
      )}
      {field.component === "datepicker" && (
        <Datepicker
          value={formData[field.id]}
          label={field.label}
          onChange={e => changeData(e, field)}
          type={field.type}
          error={errors[field.id]}
          required={field.required}
        />
      )}
      {field.component === "textarea" && (
        <Textarea
          value={formData[field.id]}
          label={field.label}
          onChange={e => changeData(e, field)}
          error={errors[field.id]}
          required={field.required}
          placeholder={field.placeholder}
          labelClassName={labelClassName}
          className={classNameTextArea}
        />
      )}
      {field.component === "singlechoice" && (
        <SingleChoice
          label={field.label}
          options={field.options}
          onChange={e => changeData(e, field)}
          error={errors[field.id]}
          required={field.required}
          checked={formData[field.id]}
        />
      )}
      {field.component === "multiplechoice" && (
        <MultipleChoice
          label={field.label}
          options={field.options}
          onChange={e => changeData(e, field)}
          error={errors[field.id]}
          required={field.required}
          array={formData[field.id]}
        />
      )}
      {field.component === "select" && (
        <Select
          label={field.label}
          options={field.options}
          onChange={e => changeData(e, field)}
          placeholder={field.placeholder}
          error={errors[field.id]}
          required={field.required}
        />
      )}
    </section>
  ));
};
